import { useIntl } from 'react-intl';

import './index.scss';

const NotFound = () => {
    const intl = useIntl();

    return (
        <div className={'error'}>
            <div className={'error__big'}>404</div>
            <div className={'error__headline'}>
                {intl.formatMessage({ id: 'general.notFound', defaultMessage: 'Seite nicht gefunden' })}
            </div>
        </div>
    );
};

export default NotFound;
